import { useGetCompany } from 'api/company/useCompanyApi';
import React from 'react';
import { TokumaComponent } from '../components';

export const TokumaContainer = () => {
  return <TokumaComponent />;
};

export default TokumaContainer;
